import n from "../node_modules/.pnpm/@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
import { getUrlQuery as a } from "../node_modules/.pnpm/@mx_fsp-mweb-utils@0.125.0/node_modules/@mx/fsp-mweb-utils/dist/index.esm.js";
var i = a(),
  o = i && i.Swimlane || "";
var t = "https://ecny.meituan.com";
var e = location.protocol;
n.runtime === 1 && (t = "".concat(e, "//stable.pay.st.sankuai.com"));
n.runtime === 2 && (t = o ? "".concat(e, "//").concat(o, "-sl-stable.pay.test.sankuai.com") : location.origin);
n.runtime === 3 && (t = location.origin);
n.runtime === 4 && (t = location.origin);
var c = {
  sendMessageApi: "".concat(t, "/ecny/walletapp/user/contractpay/sendmessage"),
  contractPaySignApi: "".concat(t, "/ecny/walletapp/user/contractpay/sign"),
  signRouting: "".concat(t, "/ecny/wallet/user/signRouting")
};
export { c as default };
